import { render, staticRenderFns } from "./DeliveryCreation.vue?vue&type=template&id=481f9e41&scoped=true&"
import script from "./DeliveryCreation.vue?vue&type=script&lang=js&"
export * from "./DeliveryCreation.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCreation.vue?vue&type=style&index=0&id=481f9e41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f9e41",
  null
  
)

export default component.exports